import { useEffect } from "react"
import { useAppDispatch } from "@/store"
import { useGetCatalogsQuery } from "@/store/apis/catalogsAPI"
import { useGetMeQuery } from "@/store/apis/playerAPI"
import { useFetchServerTimeQuery } from "@/store/apis/serverTimeAPI"
import { setIsPlayerLoaded } from "@/store/slices/player"

export const useLoad = () => {
  const dispatch = useAppDispatch()
  const { isSuccess, isError } = useGetMeQuery()
  const { isSuccess: isCatalogsSuccess, isError: isCatalogsError } =
    useGetCatalogsQuery()
  useFetchServerTimeQuery()

  // Resolve the load gate on success OR error so a failed bootstrap request
  // never strands an authenticated user on an infinite loader. A 401 is handled
  // upstream by the axios interceptor (refresh/logout → auth router); on other
  // errors we let the app render (Home falls back gracefully, reference-data
  // consumers degrade on empty catalogs). A rejected RTK Query cache entry has
  // no fulfilledTimeStamp, so a new subscriber re-runs the request — opening
  // the inventory retries /catalogs. /catalogs additionally exhausts its own
  // retry ladder before reporting an error. Proper retry UX for a persistent
  // failure is future work.
  useEffect(() => {
    const isPlayerSettled = isSuccess || isError
    const isCatalogsSettled = isCatalogsSuccess || isCatalogsError

    if (isPlayerSettled && isCatalogsSettled) {
      dispatch(setIsPlayerLoaded(true))
    }
  }, [isSuccess, isError, isCatalogsSuccess, isCatalogsError, dispatch])
}
